<script>
    import Changelog from './Changelog.svelte'
    import Tester from './Tester.svelte'
    import { testerData, testers, version } from '../../service'

    import { isLogged } from '../../store'
    import CognitoAuth from '../../cognito'

    let openLog = false
    const cognito = new CognitoAuth()
    let testersByRobot = []

    $: testerData && testers && (() => {
        if (Object.keys($testers).length) {
            $testerData.forEach(tester => {
                if(! testersByRobot[$testers['auto'][tester.tester] || 'manual'])  testersByRobot[$testers['auto'][tester.tester] || 'manual'] = []
                if(! testersByRobot[$testers['auto'][tester.tester] || 'manual'][tester.tester])  testersByRobot[$testers['auto'][tester.tester] || 'manual'][tester.tester] = []

                testersByRobot[$testers['auto'][tester.tester] || 'manual'][tester.tester] = Object.assign(tester, { robot: $testers['auto'][tester.tester] || '' })
            })
        }
        testersByRobot = Object.keys(testersByRobot)
                .sort()
                .reduce((accumulator, key) => {
                    accumulator[key] = testersByRobot[key];

                    return accumulator;
                }, {})
    })()
</script>

<div class="flex justify-between w-full h-12 shadow-md">
    <div class="flex flex-row align-ceter ml-2">
        <img src="LogoReconextTransparentV2.png" alt="Logo">
        <span class="text-xl sm:text-2xl font-semibold flex items-center p-2">
            Optiline Status Dashboard
        </span>
    </div>
    <div class="flex flex-row">
        {#if $isLogged}
            <div class="flex items-center mr-2">
                <button class="p-1 bg-sky-600 text-white font-semibold text-base flex items-center hover:text-black hover:bg-gray-400 rounded"
                        on:click={() => cognito.logout()}>
                    Log out
                </button>
            </div>
        {/if}
        <div class="flex items-center mr-2 text-center">
            <button class="p-1 bg-gray300 text-black text-xs flex items-center hover:text-black hover:bg-gray-400 xl:w-10 rounded
                    xl:h-6 xl:text-base xl:bg-gray-300 "
                    on:click={() => openLog = true}>
                { $version }
            </button>
        </div>
    </div>
</div>

{#if openLog}
    <Changelog on:close={() => openLog = false} version={ $version } />
{/if}

<Tester testerData={ testersByRobot } testers={ $testers } />
